import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import Pricing from './Pricing';
import PricingProctorCollected from './PricingProctorCollected';
import Payments from '../Payments/Payments';

const ScheduleMessaging = observer(class ScheduleMessaging extends React.Component {
  constructor() {
    super();
    this.setFees = this.setFees.bind(this);
    this.renderPricingButton = this.renderPricingButton.bind(this);
    this.submitSchedule = this.submitSchedule.bind(this);
  }

  componentWillMount() {
    const { PaymentStore, ProctorStore } = this.props.store;

    this.state = {
      step: 1,
      fees: null,
      voucherCode: null,
      disabled: false
    }

    // Set payment callback
    PaymentStore.setAfterPayment((event) => this.nextStep(event));

    // Get the pricing data
    const _this = this;
    setTimeout(function(){
      const query = `?proctorLocationSids=${_this.props.proctorLocationSid}&examSessionSid=${_this.props.sessionSid}`;

      ProctorStore.searchProctors(query, _this.setFees, null);
    });
  }

  setFees(i, data) {
    if(data.length === 0) {
      this.setState({
        disabled: true
      });
    } else {
      this.setState({
        disabled: false,
        fees: data[0].fees
      });
    }
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    }, function(){
      // Hide the close button on the last step so the
      // student has to click the return to dashboard button
      if(this.state.step === 4) {
        this.props.store.SessionStore.hideDrawerClose = true;
      }
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  submitSchedule() {
    const { ScheduleStore } = this.props.store;

    const data = {
      amount: this.state.fees.userTotal,
      currency: this.state.fees.currencyCode,
      type: 'messaging',
      messageSid: this.props.messageSid
    }

    if(this.state.fees.proctorCollected) {
      data.amount = 0;
    }

    ScheduleStore.createAppointment(this.props.examSid, this.props.sessionSid, data, () => {this.setStep(null, 4)});
  }

  renderPricingButton() {
    const { translation } = this.props;

    if(this.state.fees) {
      if(this.state.fees.userTotal > 0 && !this.state.fees.proctorCollected) {
        return (
          <button
            className="btn"
            onClick={(e) => {this.nextStep(e)}}
          >
            {translation.next}
          </button>
        )
      }

      if(this.state.fees.userTotal === 0 || this.state.fees.userTotal === null || this.state.fees.proctorCollected) {
        return (
          <button
            className="btn"
            onClick={this.submitSchedule}
          >
            {translation.schedule}
          </button>
        )
      }
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { MessageStore, SessionStore, StudentStore } = this.props.store;
    const { threadObject } = MessageStore;
    const { userTimezone } = this.props.store.SessionStore;

    let confirmedDate = null;

    if(this.props.external) {
      confirmedDate = this.props.confirmedDate;
    } else if(MessageStore.confirmedDate) {
      confirmedDate = MessageStore.confirmedDate;
    } else {
      confirmedDate = threadObject.confirmedDate;
    }

    if(!SessionStore.backgroundLoading) {
      if(this.state.disabled) {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className={`panel panel--brief`}>
              <h2 className="panel__title">{translation.disabled_msg.heading}</h2>

              <p>{translation.disabled_msg.body}</p>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/messages')}}
              >
                {translation.disabled_msg.button}
              </a>
            </div>
          </div>
        );
      } else {
        return (
          <div className="drawer__content">
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>

            <div className={`panel panel--brief ${this.statusClass(1)}`}>
              <h2 className="panel__title">{translation.confirm.heading}</h2>

              <p>{translation.confirm.body_pre}</p>

              <time className="text-code">
                {moment(confirmedDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
              </time>

              <p>{translation.confirm.body_post}</p>

              <button
                className="btn"
                onClick={(e) => {this.nextStep(e)}}
              >
                <icons.iconCalendarPlus />
                {translation.confirm.button}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(2)}`}>
              {this.state.fees && !this.state.fees.proctorCollected &&
                <Pricing
                  fees={this.state.fees}
                  scheduler={this}
                  {...this.props}
                />
              }

              {this.state.fees && this.state.fees.proctorCollected &&
                <PricingProctorCollected
                  fees={this.state.fees}
                  scheduler={this}
                  {...this.props}
                />
              }

              {this.renderPricingButton()}

              <span className="preposition--vertical">{translation.confirm.or}</span>

              <button
                className="btn--link"
                onClick={(e) => {this.prevStep(e)}}
              >
                {translation.go_back}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(3)}`}>
              <h2 className="panel__title">{translation.payment.heading}</h2>

              <Payments submit={this.submitSchedule} {...this.props} />
            </div>

            <div className={`panel panel--brief ${this.statusClass(4)}`}>
              <h2 className="panel__title">{translation.confirmed.heading}!</h2>

              <p>{translation.confirmed.body}</p>

              <time dateTime="2017-03-06t00:00" className="text-code">
                {moment(confirmedDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
              </time>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
              >
                {translation.confirmed.button}
                <icons.iconCircleRight />
              </a>
            </div>
          </div>
        );
      }
    }

    return null;
  }
})

export default translate('ScheduleMessaging')(ScheduleMessaging);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleMessaging.js